// extracted by css-extract-rspack-plugin
var _1 = "SZQOFR2iQAAGoAdi";
var _2 = "PUj3BWI2M_EjkhOd";
var _3 = "gF60OYITnF4amjwz";
var _4 = "gF60OYITnF4amjwz";
export { _1 as "modal", _2 as "overlay", _3 as "with-scroll", _4 as "withScroll" }
